// extracted by mini-css-extract-plugin
module.exports = {"resultsHeading":"RecentAreas_resultsHeading__hDdyV"};